export const REVENUE_PROVIDER_IDS = [
	"stripe",
	"lemonsqueezy",
	"polar",
	"dodopayments",
	"paddle",
	"revenuecat",
	"creem",
	"whop",
] as const;
export type RevenueProviderId = (typeof REVENUE_PROVIDER_IDS)[number];

export const STRIPE_KEY_CREATE_URL =
	"https://dashboard.stripe.com/apikeys/create?name=AgentMRR&permissions%5B%5D=rak_charge_read&permissions%5B%5D=rak_subscription_read&permissions%5B%5D=rak_product_read&permissions%5B%5D=rak_invoice_read&permissions%5B%5D=rak_credit_note_read";

export const CREEM_KEY_URL = "https://creem.io/dashboard/developers";
export const PADDLE_KEY_URL = "https://vendors.paddle.com/authentication";
export const POLAR_KEY_URL = "https://polar.sh/dashboard/settings";
export const REVENUECAT_KEY_URL = "https://app.revenuecat.com/";
export const LEMONSQUEEZY_KEY_URL = "https://app.lemonsqueezy.com/settings/api";
export const DODOPAYMENTS_KEY_URL =
	"https://app.dodopayments.com/developer/api-keys";
export const WHOP_KEY_URL = "https://whop.com/dashboard/developer/";

export const REVENUE_PROVIDER_CONFIG: Record<
	RevenueProviderId,
	{
		instructions: string[];
		keyLabel: string;
		linkLabel: string;
		linkUrl: string;
		name: string;
		placeholder: string;
	}
> = {
	stripe: {
		instructions: [
			'Scroll down and click "Create key"',
			"Don't change the permissions",
			"Keep the key so you can reopen and manage this listing",
		],
		keyLabel: "Stripe API key",
		linkLabel: "Create a read-only API key",
		linkUrl: STRIPE_KEY_CREATE_URL,
		name: "Stripe",
		placeholder: "rk_live_...",
	},
	creem: {
		instructions: [
			"Go to Developer section in your dashboard",
			"Create a new Production API key",
			"Enable READ access for all scopes",
			"Copy the generated API key and paste it here",
		],
		keyLabel: "Creem API key",
		linkLabel: "Click here to open your Creem API keys.",
		linkUrl: CREEM_KEY_URL,
		name: "Creem",
		placeholder: "creem_...",
	},
	paddle: {
		instructions: [
			"Go to Developer tools > Authentication in your Paddle Billing dashboard",
			"Create a new key (Expires: Never expires)",
			"Enable exactly these permissions: Customer (Read), Product (Read), Subscription (Read), Transaction (Read)",
			"Important: Use an API key from Paddle Billing, not Paddle Classic",
		],
		keyLabel: "Paddle API key",
		linkLabel: "Click here to open your Paddle Billing dashboard.",
		linkUrl: PADDLE_KEY_URL,
		name: "Paddle",
		placeholder: "pdl_live_apikey_...",
	},
	polar: {
		instructions: [
			"Create an organization access token",
			"Enable the metrics:read and orders:read scopes",
			"Copy the token and paste it here",
		],
		keyLabel: "Polar access token",
		linkLabel: "Open Polar dashboard settings.",
		linkUrl: POLAR_KEY_URL,
		name: "Polar",
		placeholder: "polar_oat_...",
	},
	revenuecat: {
		instructions: [
			"Create a v2 secret API key",
			"Enable charts_metrics:overview:read and charts_metrics:charts:read",
			"Paste it as project_id:secret_api_key, for example proj1ab2c3d4:sk_...",
		],
		keyLabel: "RevenueCat project and API key",
		linkLabel: "Open RevenueCat.",
		linkUrl: REVENUECAT_KEY_URL,
		name: "RevenueCat",
		placeholder: "proj1ab2c3d4:sk_...",
	},
	lemonsqueezy: {
		instructions: [
			"Go to Settings > API in your Lemon Squeezy dashboard",
			'Click "+" to create a new API key',
			"Copy the generated key and paste it here",
		],
		keyLabel: "Lemon Squeezy API key",
		linkLabel: "Open your Lemon Squeezy API settings.",
		linkUrl: LEMONSQUEEZY_KEY_URL,
		name: "Lemon Squeezy",
		placeholder: "eyJ0eXAiOi...",
	},
	dodopayments: {
		instructions: [
			"Go to Developer > API Keys in your Dodo Payments dashboard",
			'Click "Add API Key" and uncheck "Enable write access" for a read-only key',
			"Copy the generated key and paste it here",
			"Use a Live mode key, not Test mode",
		],
		keyLabel: "Dodo Payments API key",
		linkLabel: "Open your Dodo Payments API keys.",
		linkUrl: DODOPAYMENTS_KEY_URL,
		name: "Dodo Payments",
		placeholder: "dodo_live_...",
	},
	whop: {
		instructions: [
			"Open Developer > API Keys in your Whop dashboard and create a key with read access",
			"Copy your company ID (starts with biz_) from the dashboard URL",
			"Paste it as company_id:api_key, for example biz_xxxx:your_api_key",
		],
		keyLabel: "Whop company ID and API key",
		linkLabel: "Open your Whop developer settings.",
		linkUrl: WHOP_KEY_URL,
		name: "Whop",
		placeholder: "biz_xxxx:your_api_key",
	},
};
